import { createContext } from 'react';
import { ICheckIn, IModal, LoaiPhong, MainCheckInState } from './MainCheckIn.interface';

export type MainCheckInContextProps = {
    mainCheckInState: MainCheckInState;
    setModal: (data: IModal) => void;
    setFormData: (data: any) => void;
    setEventModalDiscount: (data: any) => void;
    setEventModalCredit: (data: any) => void;
    addDataTable: (data: any) => void;
    removeDataTable: () => void;
    removeItemDataTable: (data: IModal) => void;
    setSettleFlat: (data: number | undefined) => void;
    setKeyTable: (data: number) => void;
    setQuaDem: (data: boolean) => void;
    setDataCheckIn: (data: ICheckIn) => void;
    setLoaiPhong: (data: LoaiPhong) => void;
};

export const MainCheckInContext = createContext<MainCheckInContextProps>({} as MainCheckInContextProps);
